import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { GlobalErrorBoundary } from '@/components/GlobalErrorBoundary'


// Clear old localStorage data to fix iOS Safari Private Browsing crash
// This runs once per version update to clean corrupted data
const APP_VERSION = '2.0.0';
const STORAGE_VERSION_KEY = 'app_storage_version';

try {
  const currentVersion = localStorage.getItem(STORAGE_VERSION_KEY);
  if (currentVersion !== APP_VERSION) {
    // Clear all localStorage except auth-related keys
    const keysToKeep = Object.keys(localStorage).filter(key => 
      key.startsWith('sb-') || key.includes('auth')
    );
    const savedData: Record<string, string> = {};
    keysToKeep.forEach(key => {
      const value = localStorage.getItem(key);
      if (value) savedData[key] = value;
    });
    
    localStorage.clear();
    
    // Restore auth keys
    Object.entries(savedData).forEach(([key, value]) => {
      localStorage.setItem(key, value);
    });
    
    localStorage.setItem(STORAGE_VERSION_KEY, APP_VERSION);
  }
} catch (e) {
  // If localStorage fails, continue (safe-storage will handle it)
  console.warn('Storage version check failed:', e);
}

createRoot(document.getElementById("root")!).render(
  <GlobalErrorBoundary>
    <App />
  </GlobalErrorBoundary>
);
